import { useIntl } from "react-intl";

export default () => {
  const { formatMessage } = useIntl();
  return [
    {
      value: "cs",
      name: formatMessage({ id: "localization.czech" }),
    },
    {
      value: "en",
      name: formatMessage({ id: "localization.english" }),
    },
  ];
};
